var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEighteen = function SvgEighteen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.051 8.133 5 8.84l.2.663 1.74-.52v6.884h.777V8.133H7.05ZM12.95 11.879c.598-.343 1.03-.94 1.03-1.735C13.98 8.674 12.794 8 11.64 8c-1.153 0-2.34.674-2.34 2.144 0 .795.433 1.392 1.032 1.735-.765.353-1.286 1.027-1.286 1.889 0 1.458 1.186 2.232 2.595 2.232 1.408 0 2.594-.774 2.594-2.232 0-.862-.52-1.536-1.286-1.89ZM11.64 8.75c.799 0 1.564.387 1.564 1.393 0 .939-.765 1.392-1.563 1.392-.799 0-1.564-.453-1.564-1.392 0-1.006.765-1.393 1.564-1.393Zm0 6.498c-1.053 0-1.818-.487-1.818-1.481 0-.995.765-1.48 1.819-1.48 1.053 0 1.818.486 1.818 1.48s-.765 1.48-1.818 1.48ZM20 11.646h-1.974V9.68h-.71v1.966h-1.973v.708h1.974v1.966h.71v-1.966H20v-.708Z",
    fill: "#151515"
  })));
};
export default SvgEighteen;